import PropTypes from 'prop-types'
import { JobListItem } from './JobListItem'
import { CareerPageContainer, CareerPageList } from '../styled'

export function JobListings({
  positions,
  setSelectedPosition,
  selectedPosition,
  getInitials,
}) {
  const viewPosition = (position) => {
    setSelectedPosition(position)
  }

  return (
    <CareerPageContainer>
      <CareerPageList>
        {positions.map((position) => (
          <JobListItem
            key={position.id}
            company={position?.company}
            title={position?.title}
            startDate={position?.startDate}
            city={position?.city}
            country={position?.country}
            workplaceType={position?.workplaceType}
            logoUrl={position?.company?.logo}
            isHighlighted={selectedPosition?.id === position?.id}
            viewPosition={() => viewPosition(position)}
            getInitials={getInitials}
          />
        ))}
      </CareerPageList>
    </CareerPageContainer>
  )
}

JobListings.propTypes = {
  positions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      company: PropTypes.shape({
        companyName: PropTypes.string.isRequired,
        logo: PropTypes.string,
      }),
      title: PropTypes.string.isRequired,
      startDate: PropTypes.string,
      city: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired,
      workplaceType: PropTypes.string.isRequired,
    }),
  ).isRequired,
  setSelectedPosition: PropTypes.func.isRequired,
  selectedPosition: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  getInitials: PropTypes.func.isRequired,
}
